import App from "@/App.vue";

export default [
  {
    path: "/motivos-cancelamento",
    name: "reason_cancel",
    component: App,
    redirect: { name: "reason_cancel list" },
    children: [
      {
        path: "",
        name: "reason_cancel list",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/ReasonList.vue"),
        meta: {
          breadcrumb: [
            {
              text: "Motivos de Cancelamentos",
              disabled: false,
              link: false,
              to: { name: "reason_cancel" }
            }
          ],
          displayName: "Lista Motivo de Cancelamento - Lockton",
          requiresAuth: true
        }
      }
    ]
  }
];
